<template>
    <div class="mask" v-if="dataVal.flag">
        <div class="mask-content">
            <div class="mask-content-header">
                <div>批量导入报名人员</div>
                <div @click="handleRefund">
                    <el-icon name="close" size="16"></el-icon>
                </div>
            </div>
            <div class="mask-content-body">
                <div class="mask_con">
                    <div class="mask_con_step">
                        <div>第一步：点击<span @click="downloadText">下载模板</span></div>
                        <div>第二步：按照要求填写内容</div>
                    </div>
                    <div class="mask_con_upload">
                        <div class="mask-content-body-select-title">上传文件：</div>
                        <div class="mask-content-body-select-input">
                            <el-upload class="upload-demo" drag accept=".xls,.xlsx" :action="uploadfile" :limit="1"
                                :headers="headers" :file-list="fileList2" :before-upload="beforeAvatarSuccess"
                                :on-remove="handleRemove2" :on-success="handleAvatarSuccess2">
                                <div class="el-upload__text"><em>点击上传</em> / 拖拽到此区域</div>
                            </el-upload>
                        </div>
                    </div>
                    <div class="mask_con_title">数据错误明细：</div>
                    <div class="mask_con_tip">
                        <div class="mask_con_tip_body">
                            <div v-for="(item, index) in list" :key="index">{{ item }}</div>
                        </div>
                    </div>
                </div>
                <div class="mask-content-footer">
                    <div @click="handleRefund">取消</div>
                    <div @click="handleSubmit">确定</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "importPersonnel",
    props: ['dataVal'],
    data() {
        return {
            status: 0,

            headers: {
                token: localStorage.getItem("token"),
            },
            fileList2: [],
            attachs: '',
            list: []
        };
    },
    mounted() {
    },
    methods: {
        async downloadText(urls, name) {
            // 创建隐藏的可下载链接
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = this.imgurl + '/uploads/报名人员批量导入.xlsx';
            console.log(a.href)
            // 保存下来的文件名
            a.download = '导入报名人员模板';
            document.body.appendChild(a);
            a.click();
            // 移除元素
            document.body.removeChild(a);
        },
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("importPersonCall", data);
        },
        handleSubmit() {
            let data = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                form: this.form
            }
            this.$emit("importPersonCall", data);
        },
        async activityImportsignup() {
            if (this.dataVal.type) {
                let res = await this.$api.activityImportsignupnew({
                    activity_id: this.dataVal.id,
                    file: this.attachs
                })
                if (res.code == 1) {
                    this.list = res.data
                }
            } else {
                let res = await this.$api.activityImportsignup({
                    activity_id: this.dataVal.id,
                    file: this.attachs
                })
                if (res.code == 1) {
                    this.list = res.data
                }
            }
        },
        handleAvatarSuccess2(res, file, fileList) {
            if (res.code == 1) {
                fileList.forEach((item, index) => {
                    if (item.uid == file.uid) {
                        item.url = this.urls + res.data.file
                    }
                })
                this.fileList2 = fileList

                console.log(this.fileList2)
            }
        },
        beforeAvatarSuccess(file) {
            var img = file.name.substring(file.name.lastIndexOf(".") + 1);
            const suffix = (img === "xlsx" || img === "xls") ? true : false;
            console.log('file', file, img, suffix)
            // const isLt35M = file.size / 1024 / 1024 < 20; // 限制为小于35MB
            if (!suffix) {
                this.$message.error("只能上传Excel文件！");
                return false;
            }

            return suffix
        },
        handleRemove2(file, fileList) {
            this.fileList2 = fileList
            console.log(file, fileList);
        },
    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                this.status = 0
                if (newVal.flag) {
                    this.attachs = ''
                    this.fileList2 = []
                    this.list = []
                }
            },
            deep: true
        },
        fileList2: {
            handler(newVal, oldVal) {
                let imagelist = []
                newVal.forEach(item => {
                    if (item.status == "success") {
                        let url = item.url.replace(this.urls, '')
                        imagelist.push(url)
                    }
                })
                this.attachs = imagelist.toString()

                if (this.status == 0) {
                    this.status = 1
                } else if (this.status == 1) {
                    if (this.attachs) {
                        this.activityImportsignup()
                    } else {
                        this.list = []
                    }
                }
                console.log(this.attachs)
            },
            deep: true
        },
    }
};
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;

    .mask-content {
        width: 714px;
        border-radius: 10px;
        background: #FFF;
        overflow: hidden;
        position: fixed;

        .mask-content-header {
            width: 100%;
            min-height: 50px;
            background: #C12E30;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;

            div {
                color: var(--Gray-White, #FFF);
                font-size: 16px;
            }

            .el-icon-close {
                color: #FFF;
                cursor: pointer;
            }
        }

        .mask-content-body {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #FFF;
            padding: 20px 20px 20px 33px;

            .mask_con {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;

                .mask_con_step {
                    width: 100%;
                    border-radius: 10px;
                    background: #F3F3F3;
                    padding: 20px;

                    div {
                        color: #000;
                        font-size: 14px;
                        margin-top: 15px;
                        cursor: default;

                        span {
                            color: #C12E30;
                            cursor: pointer;
                        }

                        &:nth-child(1) {
                            margin-top: 0;
                        }
                    }
                }

                .mask_con_upload {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    margin-top: 15px;

                    .mask-content-body-select-title {
                        width: 87px;
                        color: #A6A6A6;
                        font-size: 14px;
                        display: flex;
                        align-items: center;

                        span {
                            color: #C12E30;
                        }
                    }

                    /deep/ .mask-content-body-select-input {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        margin-top: 10px;

                        .el-select {
                            flex: 1;
                        }

                        .el-date-editor {
                            flex: 1;
                        }

                        .mask-content-body-select-input-span {
                            width: 30px;
                            color: #A6A6A6;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .avatar-uploader {
                            .el-upload {
                                border: 1px dashed #DCDCDC;
                                background: #E7E7E7;
                            }
                        }

                        .el-upload__tip {
                            width: 100%;
                            height: 100%;
                            flex-direction: column;
                            @include flex-center(center, center);

                            .avatar-uploader-text {
                                color: rgba(0, 0, 0, 0.40);
                                font-size: 12px;
                                line-height: normal;
                                margin-top: 10px;
                            }
                        }

                        .upload-demo {
                            width: 100%;

                            .el-upload {
                                width: 100%;

                                .el-upload-dragger {
                                    width: 100%;
                                    height: 50px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                }
                            }
                        }

                        .el-upload-list {
                            display: flex;
                            flex-wrap: wrap;

                            .el-upload-list__item {
                                width: 130px;
                                border-radius: 3px;
                                background: #F3F3F3;
                                margin-left: 15px;
                                margin-top: 15px !important;

                                &:nth-child(1) {
                                    margin-left: 0;
                                }
                            }
                        }

                    }
                }

                .mask_con_title {
                    width: 100%;
                    color: #A6A6A6;
                    font-size: 14px;
                    margin-top: 17px;
                }

                .mask_con_tip {
                    width: 100%;
                    height: 313px;
                    border-radius: 3px;
                    border: 1px solid #DCDCDC;
                    background: #F3F3F3;
                    padding: 16px;
                    margin-top: 10px;

                    .mask_con_tip_body {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        overflow-y: auto;

                        div {
                            width: 100%;
                            color: #000;
                            font-size: 12px;
                            word-break: break-all;
                        }
                    }
                }
            }

            .mask-content-footer {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 28px;

                div {
                    width: 120px;
                    height: 40px;
                    color: rgba(0, 0, 0, 0.90);
                    font-size: 14px;
                    border-radius: 5px 0 0 5px;
                    background: #EDC2C3;
                    @include flex-center(center, center);
                    cursor: pointer;

                    &:nth-child(2) {
                        border-radius: 0 5px 5px 0;
                        color: rgba(255, 255, 255, 0.90);
                        background: #B30003;
                    }
                }
            }
        }
    }
}
</style>